import { useStore } from 'vuex';

export const props = {
  cartItems: {
    type: Array,
    required: true,
  },
};

export const useCartContent = (props) => {
  const store = useStore();

  const removeProduct = async (item) => {
    await store.dispatch('cartPreview/removeProduct', item);
  };

  return {
    removeProduct,
  };
};
